'use client';

import { useEffect } from 'react';
import { captureError } from '@/lib/observability/sentry';
import './_shared/shared.css';

/**
 * Next.js App Router error boundary for the whole (app) segment (train,
 * map, and any future route added under this group). Generic copy — kept
 * route-agnostic since it's shared across every screen it protects.
 */
export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
    captureError(error);
  }, [error]);

  return (
    <div className="error-boundary">
      <div className="error-boundary-panel" role="alert">
        <span className="error-boundary-badge">Signal lost</span>
        <h1 className="error-boundary-title">Something interrupted training</h1>
        <p className="error-boundary-message">
          Your progress up to this point is safe. Try again, or head back and
          pick up where you left off.
        </p>
        <div className="error-boundary-actions">
          <button
            type="button"
            className="error-boundary-btn"
            data-variant="primary"
            onClick={reset}
          >
            Retry
          </button>
          <a className="error-boundary-btn" data-variant="secondary" href="/">
            Back to home
          </a>
        </div>
      </div>
    </div>
  );
}
